// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"7df0101c","85":"6f39dee1","108":"5dcc3986","397":"9d0f571d","428":"5f17414b","524":"0c1d47fb","540":"09380f56","661":"44c3419e","669":"ff655191"}[chunkId] + ".chunk.js";
};